import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { IntlProvider } from "react-intl";
import App from "./App";
import {
  getLocale,
  loadLocaleMessages,
} from "./components/config/_localeMessages";
import { store } from "./store";
import "./index.css";
import { Provider } from "react-redux";
import { CookiesProvider } from "react-cookie";

// Resolved once per page load: ?locale= param from the relying party, else
// the cookie it was stashed in, else the browser language (see
// _localeMessages.js). Also stamped on <html lang> for AT (WCAG 3.1.1).
const locale = getLocale();
document.documentElement.lang = locale;

// English is in the main bundle and resolves immediately; de/fr/it are
// split chunks fetched here, before first render, so the page never flashes
// English on its way to the user's language. The shell's static placeholder
// covers the wait.
loadLocaleMessages(locale).then((messages) => {
  createRoot(document.getElementById("root")).render(
    <StrictMode>
      <BrowserRouter>
        <Provider store={store}>
          <CookiesProvider>
            <IntlProvider locale={locale} messages={messages}>
              <App />
            </IntlProvider>
          </CookiesProvider>
        </Provider>
      </BrowserRouter>
    </StrictMode>
  );
});
